import {Scene} from 'scene';

import { literal_price } from "ui_commons"

const Sprite = PIXI.Sprite;
const TextureCache = PIXI.utils.TextureCache;
const BitmapText = PIXI.extras.BitmapText;

export default class SceneMessage extends Scene {
    constructor(space) {
        super();

        this.space = space;

        const graphics = new PIXI.Graphics();
        graphics.beginFill(0x00000);
        graphics.drawRect(0, 0, 1920, 1080);
        graphics.endFill();

        this.fon = new Sprite(graphics.generateTexture());
        this.addChild(this.fon);

        this.messages = [];
        const createMessageFrame = (texture) => {
            let frame = new Sprite(TextureCache[texture]);
            frame.anchor.set(0.5, 0.5);
            frame.position.set(1920/2, 1080/2);
            this.addChild(frame);
            frame.visible = false;

            this.messages.push(frame);

            return frame
        }

        this.cardBackMessage = createMessageFrame('res/message_window/card_back.png');
        this.labelSecondsToCardBack = new BitmapText("", {font: "window_font", align: "center"});
        this.labelSecondsToCardBack.anchor.set(0.5, 0.5);
        this.labelSecondsToCardBack.position.set(0, 18);
        this.cardBackMessage.addChild(this.labelSecondsToCardBack);
        this.cardBackMessage.visible = false;

        this.resultMessage = createMessageFrame('res/message_window/result_message.png');
        this.resultLabel = new BitmapText("", {font: "window_font", align: "left"});
        this.resultLabel.position.set(578 - 542, 105 - 150);
        this.resultMessage.addChild(this.resultLabel);

        this.problemRFIDMessage = createMessageFrame('res/message_window/problem_card_reader.png');

        this.errorMessage = createMessageFrame('res/message_window/disable_game.png');

        this.visible = false;

        this.messageTimer = null;

        //флаг ошибки или отсутствия рфид
        this._isErrorState = false

        this.setStreamHandlers(space);

    }

    hide() {
        this.visible = false;
        this.messages.forEach(m => m.visible = false);

        if (this.messageTimer) {
            clearTimeout(this.messageTimer);
            this.messageTimer = null;
        }

        this.space.s('show_message').next(false);
    }

    show() {
        //this.messages.forEach(m => m.visible = false);

        if (this.messageTimer) {
            clearTimeout(this.messageTimer);
            this.messageTimer = null;
        }

        this.visible = true;

        this.space.s('show_message').next(true);
    }

    hideIfNothingTable() {
        let canHide = true;
        for (let i = 0; i < this.messages.length; ++i) {
            if (this.messages[i].visible) {
                canHide = false;
            }
        }

        if (canHide) {
            this.visible = false;
            if (this.messageTimer) {
                clearTimeout(this.messageTimer);
                this.messageTimer = null;
            }

            this.space.s('show_message').next(false);
        }
    }

    showCardBackMessage(on_end_timeout) {

        let second_to_end = 5;

        this.show();

        if (!this._isErrorState) {

            this.fon.alpha = 0.7;
            this.cardBackMessage.visible = true;
            this.labelSecondsToCardBack.text = second_to_end;

            const timerTick = () => {
                second_to_end--;
                if (second_to_end === 0) {
                    if (on_end_timeout) {
                        on_end_timeout();
                    }
                    //this.hide();
                    this.cardBackMessage.visible = false;
                    this.hideIfNothingTable();
                }
                else {
                    this.labelSecondsToCardBack.text = second_to_end;
                    this.messageTimer = setTimeout(timerTick, 1000);
                }
            };

            this.messageTimer = setTimeout(timerTick, 1000);
        }
    }

    showRFIDProblem() {
        this.show();
        this.fon.alpha = 1.0;
        this.problemRFIDMessage.visible = true;
    }

    setStreamHandlers(space) {

        space.s('error_driver:isError')
            .distinctUntilChanged()
            .on(show => {
                //console.log('ERROR SHOW', show);
                if (show) {
                    this.show();
                    this.fon.alpha = 1.0;
                    this.errorMessage.visible = true;
                }
                else {
                    //this.hide();
                    this.errorMessage.visible = false;
                    this.hideIfNothingTable();
                }
            });

        space.s('error_driver:isError')
            .any(space.s('card:absend_rfid'), (err, rfid) => err && rfid)
            .on(err => this._isErrorState = err);

        space.s( 'card:attach' ).on(() => {
            this.cardBackMessage.visible = false;
            this.resultMessage.visible = false;
            this.hideIfNothingTable();
        });

        space.s( 'card:remove' ).on(() => {
            this.resultMessage.visible = false;
            this.hideIfNothingTable();
        });

        space.s('card:absend_rfid')
            .distinctUntilChanged()
            .filter(absend => !absend)
            .on(() => {
                this.problemRFIDMessage.visible = false;
                this.hideIfNothingTable();
            });

        space.s('lobby_ui:stopPari')
            .with(space.s('balance'), (_, balance) => balance)
            .on(balance => {

                let gameable_money = balance.money;
                let minor_unit = balance.minor_unit;

                this.resultLabel.text = literal_price(gameable_money, minor_unit, '.');

                this.show();
                this.resultMessage.visible = true;
            })
    }
}


// WEBPACK FOOTER //
// ./src/message.es6